import { render, staticRenderFns } from "./examPackPartner.vue?vue&type=template&id=2c92bfdb&scoped=true"
import script from "./examPackPartner.vue?vue&type=script&lang=js"
export * from "./examPackPartner.vue?vue&type=script&lang=js"
import style0 from "./examPackPartner.vue?vue&type=style&index=0&id=2c92bfdb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c92bfdb",
  null
  
)

export default component.exports